<script>
const MEMBER_ADMIN_URL = 'https://member.aaden.io'

/** 门店已加入品牌时，代替会员相关页面显示：说明由品牌统一管理，并给会员后台入口 */
export default {
  name: 'JoinedBrandNotice',
  props: {
    brandName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      memberAdminUrl: MEMBER_ADMIN_URL
    }
  }
}
</script>

<template>
  <v-card
    elevation="2"
    class="pa-6"
    max-width="640"
  >
    <div class="text-h6 mb-2">
      本店已加入品牌「{{ brandName }}」
    </div>
    <div class="text-body-2 mb-4">
      <slot />
    </div>
    <v-btn
      color="primary"
      :href="memberAdminUrl"
      target="_blank"
      depressed
    >
      前往会员后台 member.aaden.io
      <v-icon
        right
        small
      >
        mdi-open-in-new
      </v-icon>
    </v-btn>
  </v-card>
</template>
